<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-5.控制器-第一人称控制器</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {genPerspectiveCamera} from '@/threejsEnv/camera.js';
import {genRenderer} from '@/threejsEnv/renderer.js';
import {PointerLockControls} from 'three/examples/jsm/controls/PointerLockControls.js';


export default {
  data(){
    return {
      scene: null,
      camera: null, 
      renderer: null, 
      cube: null,
      animationId: null,
      control: null,
      isLocked: false,
      clock: null,
      window: {
        width: 0,
        height: 0
      },
      keys: {
        KeyW: false,
        KeyA: false,
        KeyS: false,
        KeyD: false,
        Space: false, // 空格可以用于跳跃
        ShiftLeft: false, // 左Shift可以用于加速
      },
    }
  },
  mounted(){
    this.clock = new THREE.Clock();
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;

    this.scene = generateScene();
    
    this.camera = genPerspectiveCamera(this.window);
    this.camera.position.y = 2;

    const geometry = new THREE.BoxGeometry();
    const material = new THREE.MeshBasicMaterial({ color: 0x0000ff});
    
    this.cube = new THREE.Mesh(geometry, material);
    this.scene.add(this.cube);

    this.renderer = genRenderer(this.window); 

    this.control  = new PointerLockControls(this.camera, this.renderer.domElement); 
    this.control.movementSpeed = 2; 
    // 设置鼠标视角转动速度
    this.control.lookSpeed = 0.01; 
    this.control.addEventListener('lock', () => {
      console.log('鼠标已锁定，可开始移动');
      this.isLocked = true; // 自定义变量标记锁定状态
    });

    // 锁定解除（如按 ESC 键）：暂停移动
    this.control.addEventListener('unlock', () => {
      console.log('鼠标已解锁，停止移动');
      this.isLocked = false;
    });

    this.$refs.container.appendChild(this.renderer.domElement);

    this.render();
    //添加监听
    window.addEventListener('resize', this.onWindowResize);
  },
  methods:{
    render() {
      const delta = this.clock.getDelta();
      const speed = 5 * delta;
      if (this.isLocked) {
        if (this.keys.KeyW) this.camera.translateZ(-speed); // 向前
        if (this.keys.KeyS) this.camera.translateZ(speed);  // 向后
        if (this.keys.KeyA) this.camera.translateX(-speed); // 向左
        if (this.keys.KeyD) this.camera.translateX(speed);  // 向右
      }

      this.animationId = requestAnimationFrame(this.render);
      this.renderer.render(this.scene, this.camera);
    },
    onWindowResize(){
        const container = this.$refs.container;
        const width = container.clientWidth;
        const height = container.clientHeight;

        // 1. 更新相机的宽高比 (aspect)
        this.camera.aspect = width / height;
        // 【关键】更新相机的投影矩阵，使更改生效
        this.camera.updateProjectionMatrix();

        // 2. 更新渲染器的尺寸
        this.renderer.setSize(width, height);
    }
  },
  beforeDestroy(){
    cancelAnimationFrame(this.animationId);
    this.scene.remove(this.cube); // 从场景中移除模型
    this.cube.geometry.dispose(); // 释放几何体内存
    this.cube.material.dispose(); // 释放材质内存
    this.renderer.dispose(); // 释放渲染器内存
    this.renderer.domElement.remove(); // 从 DOM 中移除 canvas 元素
  },
  destroyed(){
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.cube = null;
  }
}
</script>

<style scoped>

</style>